module.exports = __webpack_public_path__ + "media/images/gdpr-badge-d85a0b4a.png";